import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import styles from './styles';
/**
 */
export default class AmityekoSkeleton extends LitElement {
    constructor() {
        super(...arguments);
        this.shape = 'default';
    }
    render() {
        return html `<div
      part="base"
      class="skeleton ${classMap({
            'skeleton--default': this.shape === 'default',
            'skeleton--circle': this.shape === 'circle',
            'skeleton--square': this.shape === 'square',
            'skeleton--rounded': this.shape === 'rounded',
        })}"
      style=${styleMap({
            '--private-skeleton-width': this.width,
            '--private-skeleton-height': this.height,
            '--private-skeleton-border-radius': this.borderRadius,
        })}
    ></div> `;
    }
}
AmityekoSkeleton.styles = styles;
__decorate([
    property()
], AmityekoSkeleton.prototype, "shape", void 0);
__decorate([
    property()
], AmityekoSkeleton.prototype, "width", void 0);
__decorate([
    property()
], AmityekoSkeleton.prototype, "height", void 0);
__decorate([
    property()
], AmityekoSkeleton.prototype, "borderRadius", void 0);
if (!customElements.get('amityeko-skeleton')) {
    customElements.define('amityeko-skeleton', AmityekoSkeleton);
}
//# sourceMappingURL=index.js.map